import { Mail, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "../../data/site";
import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

export const Contact = () => {
    const { ui } = useContent();

    return (
        <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32 section-grid">
            <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
                <SectionHeader
                    chapter={ui.contact.chapter}
                    overline={ui.contact.overline}
                    title={ui.contact.title}
                    description={ui.contact.description}
                />

                <div className="max-w-2xl">
                    <div className="space-y-8">
                        <Reveal>
                            <div className="flex items-start gap-5">
                                <div className="w-11 h-11 border border-[#4a4c42] flex items-center justify-center shrink-0">
                                    <Mail className="w-5 h-5 text-[#f6c422]" strokeWidth={1.5} />
                                </div>
                                <div>
                                    <p className="overline-text !text-[10px] mb-2">{ui.contact.emailLabel}</p>
                                    <a
                                        data-testid="contact-email-link"
                                        href={`mailto:${CONTACT.email}`}
                                        className="text-white hover:text-[#f6c422] transition-colors duration-300 text-sm break-all"
                                    >
                                        {CONTACT.email}
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <div className="flex items-start gap-5">
                                <div className="w-11 h-11 border border-[#4a4c42] flex items-center justify-center shrink-0">
                                    <MapPin className="w-5 h-5 text-[#f6c422]" strokeWidth={1.5} />
                                </div>
                                <div>
                                    <p className="overline-text !text-[10px] mb-2">{ui.contact.officeLabel}</p>
                                    <address className="not-italic text-sm text-[#a2a59d] leading-relaxed">
                                        {CONTACT.address.map((line) => (
                                            <span key={line} className="block">{line}</span>
                                        ))}
                                    </address>
                                </div>
                            </div>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <a
                                data-testid="contact-whatsapp-button"
                                href={CONTACT.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 border border-[#f6c422]/60 text-[#f6c422] font-display font-bold text-xs tracking-[0.18em] uppercase px-7 py-4 hover:bg-[#f6c422] hover:text-[#292a24] transition-colors duration-300"
                            >
                                <MessageCircle className="w-4 h-4" />
                                WhatsApp {CONTACT.whatsappLabel}
                            </a>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
